'use client';

import type {ChangeEvent} from 'react';
import {type FC} from 'react';
import clsx from 'clsx';
import {usePathname, useRouter, useSearchParams} from 'next/navigation';

import {checkboxClasses} from '@/components/checkbox';
import type {CATEGORIES_QUERY_RESULT} from '@/schemas/types';
import {i18n} from '@/utils/i18n';

import type {Filters} from './search-params-filter';
import {
	filtersToSearchParams,
	searchParamsToFilters,
} from './search-params-filter';

interface Props {
	categories?: CATEGORIES_QUERY_RESULT;
}

export const ArticleSearchFiltersClient: FC<Props> = ({categories}) => {
	const router = useRouter();
	const pathname = usePathname();
	// FIXME: fix linting error
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	const searchParams = useSearchParams()!;

	const filters: Filters = searchParamsToFilters(searchParams);

	const handleCategoryChange = (
		e: ChangeEvent<HTMLInputElement>,
		slug: string,
	) => {
		const checked = e.target.checked;

		if (checked) {
			filters.tema?.push(slug);
		} else {
			filters.tema = filters.tema?.filter((item) => item !== slug);
		}

		const searchParams = filtersToSearchParams(filters);

		router.push(`${pathname}?${searchParams.toString()}`, {scroll: false});
	};

	return (
		<form className={clsx('flex', 'flex-col', 'gap-8', 'pr-12')}>
			<fieldset className={clsx('flex', 'flex-col', 'gap-2')}>
				<legend className={clsx('text-h3', 'mb-6')}>
					{i18n.components.articleSearch.categories}
				</legend>

				{categories?.map(
					(category) =>
						category.title && (
							<label
								key={category._id}
								className={clsx(
									'flex',
									'items-center',
									'gap-6',
									'cursor-pointer',
								)}
							>
								<input
									type="checkbox"
									className={clsx(checkboxClasses)}
									onChange={(e) =>
										handleCategoryChange(
											e,
											category.slug?.current ?? '',
										)
									}
									checked={filters.tema?.includes(
										category.slug?.current ?? '',
									)}
								/>
								{category.title}
							</label>
						),
				)}
			</fieldset>
		</form>
	);
};
